
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Index from "./pages/Index";
import Results from "./pages/Results";
import DemoResults from "./pages/DemoResults";
import { RebrandingModal } from "./components/RebrandingModal";

const queryClient = new QueryClient();

const RedirectHandler = () => {
  const location = useLocation();
  const path = location.pathname;

  if (path === '/seo-score' || path === '/app/seo-score/') {
    window.location.href = '/';
    return null;
  }

  return null;
};

const App = () => {
  const [showRebrandingModal, setShowRebrandingModal] = useState(false);

  useEffect(() => {
    // Check for redirect from old URL
    const urlParams = new URLSearchParams(window.location.search);
    const origem = urlParams.get('origem');
    
    if (origem === 'seo-score') {
      setShowRebrandingModal(true);
      // Clean the URL parameter after detecting it
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete('origem');
      window.history.replaceState({}, '', newUrl.pathname);
    }

    // Handle domain redirect
    if (window.location.hostname === 'app.conversion.com.br') {
      window.location.href = 'https://seo-score.conversion.com.br' + window.location.pathname;
    }

    // Handle redirect from seo-score to page-score domain
    if (window.location.hostname === 'seo-score.conversion.com.br') {
      window.location.href = 'https://page-score.conversion.com.br/?origem=seo-score';
    }
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <RebrandingModal 
          isOpen={showRebrandingModal} 
          onClose={() => setShowRebrandingModal(false)} 
        />
        <BrowserRouter>
          <RedirectHandler />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/relatorio/:id" element={<Results />} />
            <Route path="/demo" element={<DemoResults />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
